import { notEmpty } from '@festina-life/core'
import { useMemo } from 'react'

import { useConfigurationContext } from '../../context/configurationContext'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'
import { useTemplateHierarchy } from './useTemplateHierarchy'
import { useTemplateVersionInfo } from './useTemplateVersionInfo'

/**
 * Given a template ID, will return a flattened array with all of the latest versions found
 * in its ancestor templates for the current view date.
 */
export const useInheritedTemplateVersionInfos = (templateId: string) => {
  const { viewAt } = useConfigurationContext()
  const { applicationTemplateVersionInfos: templateVersionInfos } =
    useApplicationViewOperationsContext()
  const versionInfoForCurrentDate = useTemplateVersionInfo({
    id: templateId,
    date: viewAt,
  })
  const versionHierarchyForDate = useTemplateHierarchy({
    forTemplate: versionInfoForCurrentDate,
    withReplacements: false,
  })

  const hierarchyWithoutSelf = versionHierarchyForDate.slice(0, -1)

  return useMemo(
    () =>
      hierarchyWithoutSelf
        .flatMap(
          (ancestor) =>
            templateVersionInfos.get(ancestor.identifier) ?? [ancestor],
        )
        .filter(notEmpty),
    [hierarchyWithoutSelf, templateVersionInfos],
  )
}
